import React from "react";

const LineaCentraleVerticale = () => {
    return (
        <div className="alfredovasco--w-[6px] alfredovasco--h-[10vh] alfredovasco--mx-auto -alfredovasco--mt-[5vh] -alfredovasco--mb-[5vh] alfredovasco--bg-giallino alfredovasco--relative"></div>
    );
}

export default LineaCentraleVerticale;